import { asyncGetList } from "@/apis/fetch";
import { getIdApp } from "@/apis/helpers";
import { useApiContext } from "@/setup/flexbiz-api-provider";
import { Title } from "@mantine/core";
import { useRouter } from "next/router";
import React from "react";
import NotificationItem from "./NotificationItem";

export default function NotiList() {
  const context = useApiContext();
  const router = useRouter();
  const [noti, setNoti] = React.useState(null);
  const [reFetch, setReFetch] = React.useState(1);
  const id_app = getIdApp("so1", {});
  React.useEffect(() => {
    if (!localStorage.getItem("token")) {
      context.setProgressStatus(false);
      router.push({ pathname: "/dang-nhap" });
    }
  }, [context]);
  React.useEffect(() => {
    async function fetch() {
      try {
        const list = await asyncGetList({
          access_token: context?.userInfo?.token,
          collection_name: "notification",
          options: {
            limit: 10,
            condition: {
              ["exfields.id_app"]: id_app,
              email_owner: context?.userInfo?.email,
            },
          },
        });
        // console.log(list);
        setNoti(list);
        // console.log(id_app);
      } catch (e) {
        console.log(e);
      }
    }
    context?.userInfo && fetch();
  }, [context.userInfo, reFetch]);

  return (
    <div>
      <Title order={4}>Thông báo của tôi</Title>
      {noti &&
        noti.map((item, index) => (
          <NotificationItem
            data={item}
            key={index}
            setReFetch={setReFetch}
          ></NotificationItem>
        ))}
    </div>
  );
}
